import React,{useState} from 'react'
import { faqData } from '../data/freelancer'

export default function FreelancerFaq() {
    let [activeTab, setActiveTab] = useState(1)
  return (
        <div className="accordion ms-md-4">
            {faqData.map((item,index)=>{
                return(
                    <div className="accordion-item rounded mt-2 border" key={index}>
                        <h2 className="accordion-header">
                            <button className={`accordion-button border-0 bg-light ${activeTab === item.id ? '' : 'collapsed'}`} onClick={()=>setActiveTab(item.id)}>
                                {item.title}
                            </button>
                        </h2>
                        <div className={`accordion-collapse border-0 collapse ${activeTab === item.id ? 'show' : ''}`}>
                            <div className="accordion-body text-dark"><span className="h6 text-dark">{item.name} <span className="text-danger">{item.year}</span></span> <br/><br/> {item.desc}</div>
                        </div>
                    </div>
                )
            })}
        </div>
  )
}
